import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useSnackbar } from "notistack";
import api from "../api/axios";

const initialForm = {
  full_name: "",
  phone: "",
  email: "",
  id_type: "",
  id_number: "",
  address: "",
  notes: "",
};

const DebtorForm = ({ onCreated }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!form.full_name.trim()) {
      enqueueSnackbar("Le nom complet est requis", { variant: "warning" });
      return;
    }

    try {
      setSubmitting(true);

      const payload = {
        full_name: form.full_name.trim(),
        phone: form.phone.trim() || null,
        email: form.email.trim() || null,
        id_type: form.id_type.trim() || null,
        id_number: form.id_number.trim() || null,
        address: form.address.trim() || null,
        notes: form.notes.trim() || null,
      };

      const res = await api.post("/debtors", payload);

      enqueueSnackbar("Débiteur enregistré avec succès", {
        variant: "success",
      });

      setForm(initialForm);

      if (typeof onCreated === "function") {
        onCreated(res.data);
      }
    } catch (err) {
      const msg =
        err?.response?.data?.error || "Échec de l'enregistrement du débiteur";
      enqueueSnackbar(msg, { variant: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Paper sx={{ p: 3, borderRadius: 3 }}>
      <Typography variant="h6" sx={{ fontWeight: 800, mb: 2 }}>
        Nouveau débiteur
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Nom complet"
            name="full_name"
            value={form.full_name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Téléphone"
            name="phone"
            value={form.phone}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="E-mail"
            name="email"
            value={form.email}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Type de pièce"
            name="id_type"
            value={form.id_type}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Numéro de pièce"
            name="id_number"
            value={form.id_number}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Adresse"
            name="address"
            value={form.address}
            onChange={handleChange}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            minRows={3}
            label="Observations"
            name="notes"
            value={form.notes}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2.5 }}>
        <Button variant="contained" onClick={handleSubmit} disabled={submitting}>
          {submitting ? "Enregistrement..." : "Enregistrer"}
        </Button>
      </Box>
    </Paper>
  );
};

export default DebtorForm;